import React from "react";
import PropTypes from "prop-types";
import { Editor, EditorState, RichUtils } from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import { stateFromHTML } from "draft-js-import-html";

import Toolbar from "./Toolbar";

import "./RichTextEditor.scss";

const defaultPolicies = `
	<ul>
		<li>
			All jobs requested and worked must follow department rules and regulations.
		</li>
		<li>
			Any job request that do not meet the department&#39;s rules and regulations may be denied at
			the discretion of the department.
		</li>
		<li>
			Any changes to job requests have to be submitted in a timely manner.
		</li>
		<li>
			Any electronic invoices sent via RollKall platform must be paid through the platform.
		</li>
		<li>
			All invoices sent from the platform have to be paid in a timely manner, as agreed upon with the department.
		</li>
	</ul>
`;

const RichTextEditor = ({ value, onChange }) => {
	const [editorState, setEditorState] = React.useState(() =>
		EditorState.createWithContent(stateFromHTML(value || defaultPolicies)),
	);

	const handleKeyCommand = command => {
		const newState = RichUtils.handleKeyCommand(editorState, command);
		if (newState) {
			setEditorState(newState);
			return true;
		}
		return false;
	};

	// eslint-disable-next-line consistent-return
	const myBlockStyleFn = contentBlock => {
		const type = contentBlock.getType();

		switch (type) {
			case "leftAlign":
				return "text-left";
			case "rightAlign":
				return "text-right";
			case "centerAlign":
				return "text-center";
			case "justifyAlign":
				return "text-justify";
			default:
				break;
		}
	};

	const onEditorState = newEditorState => {
		setEditorState(newEditorState);
		const html = stateToHTML(newEditorState.getCurrentContent());
		onChange(html);
	};

	return (
		<div className="editor-wrapper">
			<Toolbar
				editorState={editorState}
				setEditorState={setEditorState}
			/>
			<Editor
				editorState={editorState}
				onChange={onEditorState}
				handleKeyCommand={handleKeyCommand}
				blockStyleFn={myBlockStyleFn}
			/>
		</div>
	);
};

RichTextEditor.propTypes = {
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
};

RichTextEditor.defaultProps = {};

export default RichTextEditor;
